import * as React from 'react';
import { Form, TextArea, Label } from 'semantic-ui-react';

interface Props {
    input: Record<string, any>;
    label?: string;
    meta: {
        touched?: boolean;
        error?: string;
    };
    name: string;
}

export class RenderTextArea extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const {
            input,
            label,
            meta: { touched, error },
            name,
            ...props
        } = this.props;
        return (
            <Form.Field error={!!(touched && error)}>
                {label && <label htmlFor={name}>{label}</label>}
                <TextArea {...input} {...props} />
                {!!(touched && error) && (
                    <Label basic color="red" pointing>
                        {error}
                    </Label>
                )}
            </Form.Field>
        );
    }
}

export default RenderTextArea;
